const ProposalAdvisedEnum = Object.freeze({
    YES: 'YES',
    XO: 'XO',
    PROFESSIONAL: 'PROFESSIONAL'
});

export default ProposalAdvisedEnum;
